const getQuestion = [
  {
    id: '1',
    title: 'Proč využít JHavel Finance a ne nějakého jiného zprostředkovatele?',
    text: `Protože máme zaměření jen na úvěry a jen pro SVJ a BD. Narozdíl od mnoha jiných
    zprostředkovatelů Vám zajistíme celkový servis a to i po dokončení smluv v období čerpání
    a po čerpání úvěru. Navíc Vám připravíme detailní vyhodnocení produktů, doporučení výběru a
    zajistíme přípravu všech podkladů. Máme úzké zaměření, jen na tuto problematiku.`,
  },
  {
    id: '2',
    title: 'Co nás bude stát spolupráce s JHavel Finance s.r.o.?',
    text: `Nic, jsme jako zprostředkovatelé hodnoceni od našich partnerů, naše
    ohodnocení ani neovlivní nabídky pro Vás.`,
  },
  {
    id: '3',
    title: 'Dostaneme přes JHavel Finance s.r.o. stejné nabídky jako při oslovení partnerů?',
    text: `Ano, naši partneři nám nechávají stejné podmínky, jako, kdybyste je poptali „na přímo“,
    ale my Vám zajistíme správné nastavení poptávek, zajištění nabídek od všech partnerů najednou a
    ušetříme Vám mnoho starostí s vyřízením výběrového řízení na úvěr a s vyřízením úvěru samotného.`,
  },
  {
    id: '4',
    title: 'Dostaneme od velkých zprostředkovatelských firem lepší podmínky?',
    text: `Ne, tento příslib, že díky své velikosti vymohou lepší podmínky u bankovních domů
    je oblíbenou obchodní taktikou, ale zprostředkovatelé dostanou vždy stejnou nabídku a je jedno,
    přes koho ji řešíte. Zprostředkovatelé toto často uvádí, jen, aby si přitáhli klienta k sobě...`,
  },
  {
    id: '5',
    title: 'V jakém časovém období dokážete zajistit nabídky od partnerů?',
    text: 'Nabídky od většiny partnerů zajistíme do pěti pracovních dní.',
  },
  {
    id: '6',
    title: 'Jakým způsobem provádíte vyhodnocení a doporučení nabídek?',
    text: `Na úvodní schůzce s Vámi projdeme Vaše požadavky na produkt. Následně Vám připravíme
    vyhodnocení nabídek dle celkových nákladů produktů a nastavení kritérií dle Vašich požadavků.`,
  },
  {
    id: '7',
    title: 'Jaké podklady nám předáte v rámci vyhodnocení nabídek?',
    text: 'Předáme Vám detailní vyhodnocení parametrů vypracované od nás a všechny finální nabídky od partnerů.',
  },
  {
    id: '8',
    title: 'Je možné měnit zadání již poptaných parametrů úvěru?',
    text: 'Ano, je to možné, ale je třeba počítat s časem na znovu oslovení partnerů a zpracování změn.',
  },
  {
    id: '9',
    title: 'Jak probíhají podpisy smluv?',
    text: 'Smlouvy Vám doručíme a následně je po podpisech opět doručíme naším partnerům.',
  },
  {
    id: '10',
    title: 'V čem spočívá péče ze strany JHavel Finance s.r.o.  v období čerpání úvěru?',
    text: `Pomůžeme Vám s kontrolou a doručením všech podkladů uvedených v podmínkách čerpání v
    úvěrové smlouvě a převezmeme od Vás a doručíme partnerům pokyny k čerpání úvěru. Po celou dobu
    čerpání jsme Vám k dispozici.`,
  },
  {
    id: '11',
    title: 'V čem spočívá péče ze strany Jhavel Finance s.r.o.  v období splácení úvěru?',
    text: `Hlídáme Vám konec fixace úrokové sazby a včas, před jeho koncem Vás oslovíme a připravíme
    Vám případné nabídky na refinancování úvěru. Pokud Vám stávající banka nenabídne nejlepší podmínky
    na pokračovaní v původní úvěrové smlouvě, můžete úvěr refinancovat jinam, kde máte lepší podmínky.`,
  },
  {
    id: '12',
    title: 'Na jaké účely lze úvěry čerpat?',
    text: 'Vypsané účely najdete v sekci úvěry, ale lze řešit v podstatě cokoliv dle konzultace.',
  },
  {
    id: '13',
    title: 'Jak velký úvěr můžeme získat?',
    text: `Maximálně do 1 000 000 Kč na bytovou jednotku bez zajištění, dle podmínek jednotlivých partnerů.`,
  },
  {
    id: '14',
    title: 'Jaká může být maximální doba splatnosti?',
    text: 'Většina partnerů nabízí splatnost až 25 let, u některých se dá nastavit splatnost i na 30 let.',
  },
  {
    id: '15',
    title: 'Potřebujeme na rekonstrukci vlastní zdroje?',
    text: 'Ne, většina partnerů nabízí úvěry bez nutnosti vlastních zdrojů.',
  },
  {
    id: '16',
    title: 'Musíme zastavit nemovitost?',
    text: 'Ne, většina úvěrů se vejde do limitu na úvěr bez zajištění.',
  },
  {
    id: '17',
    title: 'Jak si máme nastavit platnost úrokové sazby?',
    text: `S nastavením fixace úrokové sazby Vám pomůžeme na konzultaci, nejčastěji se nastavuje na 3 roky,
    5 let, 10 let, 15 let, v atypických případech i na delší období.`,
  },
  {
    id: '18',
    title: 'Musíme mít u vybraného partnera běžný účet?',
    text: 'Ne, většina partnerů nepožaduje převedení platebního styku.',
  },
  {
    id: '19',
    title: 'Jak je možné využívat mimořádné splátky?',
    text: `Dle podmínek jednotlivých partnerů, někteří umožňují mimořádné splátky libovolně.
    Někteří s určitými limity, někteří jen z dotace nebo při konci fixace úrokové sazby. Toto
    vždy zohledňujeme při doporučení daných nabídek.`,
  },
  {
    id: '20',
    title: 'Jaké podklady budeme potřebovat pro získání úvěru?',
    text: `Požadavky na seznam podkladů jsou u partnerů podobné, ale každý vyžaduje trochu něco
    jiného. My Vám zajistíme přípravu podkladů dle výběru financující instituce. Většinu podkladů
    připravíme my ve spolupráci s Vaší správcovskou firmou a následně Vás požádáme o doplnění
    zbývajících materiálů. Seznamy podkladů s Vámi projdeme na osobní schůzce.`,
  },
  {
    id: '21',
    title: 'Jaké poplatky od partnerů nás čekají?',
    text: `Poplatky ze všech nabídek Vám připravíme do vyhodnocení nabídek a porovnáme je navzájem tak,
    abyste si snadno vybrali nejlepší variantu.`,
  },
  {
    id: '22',
    title: 'Je možné do úvěru zahrnout již dříve financované opravy?',
    text: 'Ano, je to možné, vždy dle individuálních podmínek partnerů.',
  },
];

export default getQuestion;
